import React, { useState, useEffect } from "react";
import { config } from "./config"; // 加载配置
import "./Form.css";
import {
  fetchData,
  insertData,
  deleteData,
  fetchData_from_patient,
} from "./DataFetcher";
import { Button, View } from "@aws-amplify/ui-react";

const debug = config.debug();
const today = config.getUTC8Time();
let dm = `${String(today.getMonth() + 1).padStart(2, "0")}${String(
  today.getDate()
).padStart(2, "0")}`
  .split("")
  .reverse()
  .join("");
let todayString = `${today.getFullYear()}-${String(
  today.getMonth() + 1
).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
// console.log("todayString", todayString);
const peopleList = debug
  ? [
      {
        patient: "李生生",
        birthday: "20210808",
        ID: "A128173855",
        phone: "0988553099",
        gender: "男",
      },
      {
        patient: "王小明",
        birthday: "20190512",
        ID: "A234567890",
        phone: "0988123456",
        gender: "男",
      },
      {
        patient: "陳美麗",
        birthday: "20180120",
        ID: "A345678901",
        phone: "0988765432",
        gender: "女",
      },
    ]
  : [
      {
        patient: "",
        birthday: "",
        ID: "",
        phone: "",
        gender: "",
      },
    ];

export const checkIsFull = async (
  clinic_name,
  selectedFirstFollow,
  date,
  hour,
  time,
  setOrginalData,
  setData
) => {
  let { originalData_temp, data_temp } = await fetchData(clinic_name);
  setOrginalData(originalData_temp);
  setData(data_temp);

  if (selectedFirstFollow === "first") {
    if (data_temp[date].hours[hour][time].isFullFirst) {
      // render the form again
      // setShowForm(false);
      // window.alert("此時段已額滿，請選擇其他時段");
      // setAlertMessage("此時段已額滿，請選擇其他時段"); // 设置警告消息
      return true;
    }
  } else if (selectedFirstFollow === "follow") {
    if (data_temp[date].hours[hour][time].isFullAll) {
      // setShowForm(false);
      // setAlertMessage("此時段已額滿，請選擇其他時段");
      return true;
    }
  }

  return false;
};
export const checkIsReapeat = async (
  clinic_name,
  setOrginalData,
  setData,
  ID
) => {
  let { originalData_temp, data_temp } = await fetchData(clinic_name);
  setOrginalData(originalData_temp);
  setData(data_temp);

  for (let data_temp of originalData_temp) {
    if (data_temp.ID === ID && data_temp.clinic === clinic_name) {
      return data_temp; // 这将退出整个函数
    }
  }

  return false;
};

export const checkIsRepeatForSelectedDay = async (
  clinic_name,
  setOrginalData,
  setData,
  ID,
  selectedDate
) => {
  let { originalData_temp, data_temp } = await fetchData(clinic_name);
  setOrginalData(originalData_temp);
  setData(data_temp);

  for (let data_temp of originalData_temp) {
    if (
      data_temp.ID === ID &&
      data_temp.clinic === clinic_name &&
      data_temp.date.startsWith(selectedDate)
    ) {
      return data_temp;
    }
  }

  return false;
};
export function checkIsFirst(dataFromPatient) {
  if (dataFromPatient.length === 0) {
    return true;
  } else if (dataFromPatient[0]?.first) {
    return true;
  }
  return false;
}

export function checkMatchBday(dataFromPatient, event) {
  let bday = event.target.elements.birthday.value;
  let bdayData = dataFromPatient[0].birthday;
  if (dataFromPatient[0].birthday === event.target.elements.birthday.value) {
    return true;
  }
  return false;
}

export const AlertMsg = ({ message, onClose }) => {
  return (
    <div className="modal">
      <div className="modal-content">
        <p>{message}</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export const ConfirmMsg = ({ confirmMessage, onConfirm, onCancel }) => {
  return (
    <div
      className="modal"
      style={{ display: confirmMessage ? "block" : "none" }}
    >
      <div className="modal-content">
        <p dangerouslySetInnerHTML={{ __html: confirmMessage }}></p>
        <button onClick={onConfirm}>確認</button>
        <button onClick={onCancel}>取消</button>
      </div>
    </div>
  );
};

export const Notification = ({ clinic_name }) => {
  return (
    <View>
      <br />
      <h4>{clinic_name}兒童成長發育專科門診注意事項：</h4>
      <h5> 掛號須知</h5>
      <ul>
        <li>
          <strong>
            初診複診：若您第一次使用本預約系統，即便之前在菡生/宥宥有就診紀錄，也需選擇初診掛號。初診個案請準備過去幾年的身高體重紀錄。新北市學童可使用「新北校園通」App；其他縣市可向學務處/健康中心索取；小學低年級以前請攜帶寶寶手冊。本門診為身高成長、青春期發育專科，非【兒童發展評估】門診。
          </strong>
        </li>
        <li>
          <strong>
            門診費用：本門診為自費，採現金收費。基本費用包含掛號費(250元)和醫師諮詢費（初診500元、複診300元）。初步評估後，可能另收骨齡等費用。本診所採用新型骨齡專用X光機，孩童接受的輻射劑量約為一般X光機的五分之一，骨齡檢查費為1000元。
          </strong>
        </li>
        <li>
          預約報到：本專科採時段預約制，請於預約時段前10分鐘至一樓櫃檯掛號報到。例如，若預約時間為16:00-16:30，請於15:50報到。
        </li>
        <li>
          看診順序：看診時將優先看預約時段已到的患者，每一時段可能有2-3位病人，並依報到順序看診。
        </li>
        <li>
          過號規定：超過預約時段報到者視為過號，需等候五位患者看診後才輪到。
        </li>
        <li>
          診間時間：因每位孩童看診時間略有不同，實際進診間的時間需根據現場情況決定。
        </li>
        <li>
          取消預約：網路預約後，如需取消掛號，請用本網頁查詢功能，於前一天24:00之前透過網路取消，看診當日無法網路取消。若不可抗力因素請致電診所。兩次預約未到，則三個月內僅限現場掛號，或由現場人員協助處理。
        </li>
        <li>
          現場掛號：開診前兩小時將關閉當日的網路預約系統，如需掛號請至現場。依當日人數提供一定數量的現場名額。成功在一樓櫃檯掛號後，請至本網頁點選「現場號」，並輸入資料完成報到。
        </li>
        <li>
          衛教資訊：歡迎追蹤李醫師粉專，隨時掌握長高資訊！
          <a
            href="https://www.facebook.com/share/Zof6v8r6EdZrdSiX/?mibextid=LQQJ4d"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.facebook.com/share/Zof6v8r6EdZrdSiX/?mibextid=LQQJ4d
          </a>
        </li>
      </ul>
      <br />
      <br />
    </View>
  );
};

export const AppointmentFormFirst = ({
  showForm, // 控制表單是否顯示
  setShowForm, // 控制表單是否顯示
  selectDate, // 選擇的日期
  setData,
  setOrginalData,
  selectHour,
  selectedFirstFollow,
  clinic_name,
  setRegistrationOrQuery,
  onsite,
  // alertMessage,
  // ,
}) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmResult, setConfirmResult] = useState(null);
  //randomly select a person from the peopleList
  const randomPerson =
    peopleList[Math.floor(Math.random() * peopleList.length)];
  const showConfirmDialog = (message) => {
    return new Promise((resolve) => {
      setConfirmMessage(message);
      // setConfirm(true);

      const handleConfirm = () => {
        // setConfirm(false);
        setConfirmMessage("");
        resolve(true);
      };

      const handleCancel = () => {
        // setConfirm(false);
        setConfirmMessage("");
        resolve(false);
      };
      setConfirmResult({ handleConfirm, handleCancel });
    });
  };
  const handleSubmit = async (
    event,
    selectDate,
    // insertData,
    setData,
    setOrginalData,
    setShowForm,
    selectedFirstFollow,
    selectHour,
    clinic_name,
    setRegistrationOrQuery,
    setAlertMessage
  ) => {
    event.preventDefault();

    const name = event.target.elements.patient.value;
    const phone = event.target.elements.phone.value;
    const ID = event.target.elements.ID.value.toUpperCase();
    const gender = event.target.elements.gender.value;
    const birthday = event.target.elements.birthday.value;
    const email = event.target.elements.email.value;
    // const verification = event.target.elements.verification.value;
    const time = event.target.elements.timeTable.value;
    const hour = selectHour[0];
    const doctor = selectHour[1].doctor;
    const date = selectDate[0];
    const referral = event.target.elements.referral.value;
    const residence = event.target.elements.residence.value;
    let verification = "";
    if (onsite) {
      verification = event.target.elements.verification.value;
    }
    const dataToInsert = {
      clinic: clinic_name,
      date: `${date}_${time}_${ID}`,
      time: time,
      name: name,
      phone: phone,
      ID: ID,
      email: email,
      hour: hour,
      gender: gender,
      birthday: birthday,
      first: selectedFirstFollow === "first" ? true : false,
      doctor: doctor,
      referral: referral,
      residence: residence,
      // verification: verification,
    };
    //! 確認是否有複診資料
    let dataFromPatient = await fetchData_from_patient(
      event.target.elements.ID.value
    );
    console.log("dataFromPatient", dataFromPatient);
    if (!checkIsFirst(dataFromPatient)) {
      setAlertMessage("您的資料已建過檔，請選擇複診重新掛號");
      return;
    }
    //! 確認填入的資料格式是否都正確, 只有在初診時才需要檢查, 因為複診只會輸入證件號碼和生日
    const validate = (dataToInsert, setAlertMessage) => {
      const nameRegex = /^[\u4e00-\u9fa5a-zA-Z]{2,}$/; // 假設姓名只能包含中文字符或英文字符，並且至少包含兩個字符
      const phoneRegex = /^[0-9]{10}$/; // 假設手機號碼為10位數字
      const regexBirthday = /^\d{4}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/;
      const idRegex = /^[a-zA-Z0-9]{9,}$/; // ID至少9碼，只能包含英文和數字

      if (!nameRegex.test(dataToInsert.name)) {
        setAlertMessage(
          "請填寫正確的姓名格式, 如: 王小明, 李大衛, 張三, 至少包含兩個中文字符或英文字符且前後不能有空白"
        );
        return false;
      } else if (!phoneRegex.test(dataToInsert.phone)) {
        setAlertMessage("請填寫正確的手機號碼，如0988123456");
        return false;
      } else if (!regexBirthday.test(dataToInsert.birthday)) {
        setAlertMessage("請填寫正確的生日格式，如:20210701");
        return false;
      } else if (!idRegex.test(dataToInsert.ID)) {
        setAlertMessage(
          "請填寫正確的證件號碼格式，至少9碼，只能包含英文和數字，且前後不能有空白"
        );
        return false;
      }
      return true;
    };
    if (!validate(dataToInsert, setAlertMessage)) {
      return;
    }
    //! 只有現場掛號才需要檢查驗證碼
    if (onsite) {
      if (verification !== dm) {
        setAlertMessage("驗證碼錯誤，請重新輸入");
        return;
      }
    }
    //! 只有不是現場掛號才需要檢查是否額滿
    if (!onsite) {
      let isFull = await checkIsFull(
        clinic_name,
        selectedFirstFollow,
        date,
        hour,
        time,
        setShowForm,
        setOrginalData,
        setData,
        setAlertMessage
      );
      if (isFull) {
        setAlertMessage("此時段已額滿，請選擇其他時段");
        let { originalData_temp, data_temp } = await fetchData(clinic_name);
        setData(data_temp);
        return;
      }
    }
    //! 只有初診才需要檢查是否重複預約
    let isRepeat = await checkIsReapeat(
      clinic_name,
      setOrginalData,
      setData,
      ID
    );
    if (isRepeat) {
      const [dateSlot, timeSlot, index] = isRepeat.date.split("_");
      setAlertMessage(`您已經在${dateSlot} ${timeSlot}預約過了,請勿重複預約`);
      // setShowForm(false);
      return;
    }

    const confirm = await showConfirmDialog(`以下資訊正確嗎?<br />
      姓名: ${name}<br />
      生日: ${birthday}<br />
      電話: ${phone}<br />
      電子信箱: ${email}<br />
      證件號碼: ${ID}<br />
      性別: ${gender}<br />
      預約日期: ${date}<br />
      預約時段: ${time}(${hour})<br />
      預約醫師: ${doctor}<br />
      診別: ${selectedFirstFollow === "first" ? "初診" : "複診"}<br />
      您是如何知道本專科門診: ${referral}<br />
      您居住的區域為: ${residence}<br />
    `);
    if (!confirm) {
      return;
    }

    let result = await insertData(dataToInsert);
    if (result) {
      let { originalData_temp, data_temp } = await fetchData(clinic_name);
      console.log("originalData_temp", originalData_temp);
      console.log("data_temp", data_temp);

      setOrginalData(originalData_temp);
      setData(data_temp);
      setShowForm(false);
      console.log("預約已完成");
      setRegistrationOrQuery(
        `registrationCompleted_${date}_${hour}_${time}_${name}_${
          selectedFirstFollow === "first" ? "初診" : "複診"
        }_${onsite}`
      );
    } else {
      setData(false);
    }

    // if (confirmed) {
    //   console.log("insertdata:", dataToInsert);
    //   // insertData(dataToInsert, setData, setOrginalData, clinic_name);
    //   setShowForm(false);
    //   console.log("預約已完成");
    // } else {
    //   // 不執行任何操作
    //   console.log("取消操作");
    // }
  };
  return (
    <div>
      <div className="modal" style={{ display: showForm ? "block" : "none" }}>
        <div className="modal-content">
          {alertMessage && (
            <AlertMsg
              message={alertMessage}
              onClose={() => setAlertMessage("")}
            />
          )}
          {confirmMessage && confirmResult && (
            // <div>{alertMessage}</div>
            <ConfirmMsg
              confirmMessage={confirmMessage}
              onConfirm={confirmResult.handleConfirm}
              onCancel={confirmResult.handleCancel}
            />
          )}
          <span className="close" onClick={() => setShowForm(false)}>
            &times;
          </span>

          <p className="header">
            您預約的門診為兒童成長發育專科(自費)(
            {selectedFirstFollow === "first" ? "初診" : "複診"})
          </p>
          <p className="header">
            時段為 {selectDate} {selectHour[0]} {selectHour[1].doctor}醫師
          </p>
          <p>
            <strong>姓名、生日、證件號碼請輸入看診者的資訊</strong>
          </p>
          <form
            onSubmit={(event) =>
              handleSubmit(
                event,
                selectDate,
                // insertData,
                setData,
                setOrginalData,
                setShowForm,
                selectedFirstFollow,
                selectHour,
                clinic_name,
                setRegistrationOrQuery,
                setAlertMessage
              )
            }
          >
            <label htmlFor="patient">姓名:</label>
            <input
              type="text"
              id="patient"
              name="patient"
              required
              defaultValue={randomPerson.patient}
              placeholder="請輸入看診者(孩子)姓名"
            />

            <label htmlFor="phone">電話:</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              defaultValue={randomPerson.phone}
              placeholder="請輸入家長手機號碼"
              required
            />

            <label htmlFor="email">電子信箱:</label>
            <input
              type="email"
              id="email"
              name="email"
              // defaultValue={randomPerson.email}
              placeholder="請輸入家長電子信箱"
            />
            <label htmlFor="ID">證件號碼:</label>
            <input
              type="text"
              id="ID"
              name="ID"
              required
              placeholder="看診者身份證或其它證件"
              defaultValue={randomPerson.ID}
            />

            <label htmlFor="birthday">出生日期 (Birthday):</label>
            <input
              type="text"
              id="birthday"
              name="birthday"
              required
              placeholder="請填寫西元生日 如:20210701"
              defaultValue={randomPerson.birthday}
            />

            <label htmlFor="gender">性別:</label>
            <select id="性別" name="gender" defaultValue={randomPerson.gender}>
              <option value="男">男</option>
              <option value="女">女</option>
            </select>
            <label htmlFor="referral">您是如何知道本專科門診：(選填)</label>
            <select id="referral" name="referral">
              <option value="">請選擇</option>
              <option value="之前看過李醫師">之前看過李醫師</option>
              <option value="親友介紹">親友介紹</option>
              <option value="Google搜尋">Google搜尋</option>
              <option value="李醫師FB粉專">李醫師FB粉專</option>
              <option value="李醫師IG粉專">李醫師IG粉專</option>
              <option value="診所粉專">診所粉專</option>
              <option value="本診所其他醫師轉介">本診所其他醫師轉介</option>
              <option value="診所簡訊通知">診所簡訊通知</option>
              <option value="本診所文宣(如影片、小卡等)">
                本診所文宣(如影片、小卡等)
              </option>
              <option value="其他">其他</option>
            </select>

            <label htmlFor="residence">您居住的區域為:(選填)</label>
            <select id="residence" name="residence">
              <option value="">請選擇</option>
              <option value="台北市">台北市</option>
              <option value="板橋區">板橋區</option>
              <option value="土城區">土城區</option>
              <option value="蘆洲區">蘆洲區</option>
              <option value="三重區">三重區</option>
              <option value="中和區">中和區</option>
              <option value="永和區">永和區</option>
              <option value="樹林區">樹林區</option>
              <option value="新莊區">新莊區</option>
              <option value="泰山區">泰山區</option>
              <option value="林口區">林口區</option>
              <option value="桃園市">桃園市</option>
              <option value="基隆市">基隆市</option>
              <option value="其他">其他</option>
            </select>
            {onsite && (
              <>
                <label htmlFor="verification">驗證碼:</label>

                <input
                  type="text"
                  id="verification"
                  name="verification"
                  required
                  placeholder="請和櫃檯索取驗證碼"
                />
              </>
            )}

            <p className="header">請選擇您想要預約的時段</p>
            {onsite ? (
              <div key="onsite">
                <input
                  type="radio"
                  id="onsite"
                  name="timeTable"
                  value="onsite"
                  disabled={false}
                  defaultChecked={true}
                />
                <label htmlFor="onsite" style={{ color: "black" }}>
                  現場號
                </label>
              </div>
            ) : (
              (() => {
                let firstEnabledSet = false;
                return Object.keys(selectHour[1]).map((key) => {
                  if (!key[1].toString().match(/\d+/)) {
                    return null;
                  }

                  const isfull =
                    selectedFirstFollow === "first"
                      ? selectHour[1][key].isFullFirst
                      : selectHour[1][key].isFullAll;
                  const shouldBeDefaultChecked = !isfull && !firstEnabledSet;
                  if (shouldBeDefaultChecked) {
                    firstEnabledSet = true;
                  }

                  return (
                    <div key={key}>
                      <input
                        type="radio"
                        id={key}
                        name="timeTable"
                        value={key}
                        disabled={isfull}
                        defaultChecked={shouldBeDefaultChecked}
                      />
                      <label
                        htmlFor={key}
                        style={{ color: isfull ? "gray" : "black" }}
                      >
                        {key}
                        {isfull && "(額滿)"}
                        {debug && (
                          <>
                            ({selectHour[1][key].people.first.length}/
                            {selectHour[1][key].people.follow.length})
                          </>
                        )}
                      </label>
                    </div>
                  );
                });
              })()
            )}

            <input type="submit" value="提交" />
            <input
              type="button"
              value="取消"
              onClick={() => setShowForm(false)}
            />
            {/* {console.log("selectHour:", selectHour)} */}
          </form>
        </div>
      </div>
    </div>
  );
};
export const AppointmentFormFollow = ({
  showForm,
  setShowForm,
  setOrginalData,
  selectDate,
  // insertData,
  setData,
  selectHour,
  selectedFirstFollow,
  clinic_name,
  setRegistrationOrQuery,
  onsite,
}) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmResult, setConfirmResult] = useState(null);
  //randomly select a person from the peopleList
  const randomPerson =
    peopleList[Math.floor(Math.random() * peopleList.length)];
  const showConfirmDialog = (message) => {
    return new Promise((resolve) => {
      setConfirmMessage(message);
      // setConfirm(true);

      const handleConfirm = () => {
        // setConfirm(false);
        setConfirmMessage("");
        resolve(true);
      };

      const handleCancel = () => {
        // setConfirm(false);
        setConfirmMessage("");
        resolve(false);
      };
      setConfirmResult({ handleConfirm, handleCancel });
    });
  };
  const handleSubmit = async (
    event,
    selectDate,
    // insertData,
    setData,
    setOrginalData,
    setShowForm,
    selectedFirstFollow,
    selectHour,
    clinic_name,
    setRegistrationOrQuery,
    setAlertMessage
  ) => {
    event.preventDefault();

    //! 確認是否有複診資料
    let dataFromPatient = await fetchData_from_patient(
      event.target.elements.ID.value.toUpperCase()
    );
    console.log("dataFromPatient", dataFromPatient);
    if (checkIsFirst(dataFromPatient)) {
      setAlertMessage("找不到複診資料，請確認證件號碼是否正確, 或是選擇初診");
      return;
    }

    if (!checkMatchBday(dataFromPatient, event)) {
      setAlertMessage(
        "資料不正確，請確認生日日期是否正確,應如20210821, 或是致電診所確認"
      );
      return;
    }

    if (
      await checkIsRepeatForSelectedDay(
        clinic_name,
        setOrginalData,
        setData,
        event.target.elements.ID.value,
        selectDate
      )
    ) {
      setAlertMessage("請勿重複預約同一天");
      return;
    }

    console.log("生日正確");
    dataFromPatient = dataFromPatient[0];
    // return;
    const name = dataFromPatient.name;
    const phone = dataFromPatient.phone;
    const ID = dataFromPatient.ID;
    const gender = dataFromPatient.gender;
    const birthday = dataFromPatient.birthday;
    const email = dataFromPatient?.email;
    // const verification = event.target.elements.verification.value;
    const time = event.target.elements.timeTable.value;
    const hour = selectHour[0];
    const doctor = selectHour[1].doctor;
    const date = selectDate[0];
    let verification = "";
    if (onsite) {
      verification = event.target.elements.verification.value;
    }

    const dataToInsert = {
      clinic: clinic_name,
      date: `${date}_${time}_${ID}`,
      time: time,
      name: name,
      phone: phone,
      ID: ID,
      email: email,
      hour: hour,
      gender: gender,
      birthday: birthday,
      first: selectedFirstFollow === "first" ? true : false,
      doctor: doctor,
    };

    //! 只有現場掛號才需要檢查驗證碼
    if (onsite) {
      if (verification !== dm) {
        setAlertMessage("驗證碼錯誤，請重新輸入");
        return;
      }
    }
    //! 只有不是現場掛號才需要檢查是否額滿
    if (!onsite) {
      let isFull = await checkIsFull(
        clinic_name,
        selectedFirstFollow,
        date,
        hour,
        time,
        setShowForm,
        setOrginalData,
        setData,
        setAlertMessage
      );
      if (isFull) {
        setAlertMessage("此時段已額滿，請選擇其他時段");
        let { originalData_temp, data_temp } = await fetchData(clinic_name);
        setData(data_temp);
        return;
      }
    }
    const confirm = await showConfirmDialog(`以下資訊正確嗎?<br />
      姓名: ${name}<br />
      生日: ${birthday}<br />
      電話: ${phone}<br />
      電子信箱: ${email}<br />
      證件號碼: ${ID}<br />
      性別: ${gender}<br />
      預約日期: ${date}<br />
      預約時段: ${time}(${hour})<br />
      預約醫師: ${doctor}<br />
      診別: ${selectedFirstFollow === "first" ? "初診" : "複診"}
    `);
    if (!confirm) {
      return;
    }

    let result = await insertData(dataToInsert);
    if (result) {
      let { originalData_temp, data_temp } = await fetchData(clinic_name);
      // console.log("originalData_temp", originalData_temp);
      // console.log("data_temp", data_temp);

      setOrginalData(originalData_temp);
      setData(data_temp);
      setShowForm(false);
      console.log("預約已完成");
      setRegistrationOrQuery(
        `registrationCompleted_${date}_${hour}_${time}_${name}_${
          selectedFirstFollow === "first" ? "初診" : "複診"
        }_${onsite}`
      );
    } else {
      setData(false);
    }
  };
  return (
    <div className="modal">
      <div className="modal-content">
        {alertMessage && (
          // <div>{alertMessage}</div>
          <AlertMsg
            message={alertMessage}
            onClose={() => setAlertMessage("")}
          />
        )}
        {confirmMessage && confirmResult && (
          // <div>{alertMessage}</div>
          <ConfirmMsg
            confirmMessage={confirmMessage}
            onConfirm={confirmResult.handleConfirm}
            onCancel={confirmResult.handleCancel}
          />
        )}
        <span className="close" onClick={() => setShowForm(false)}>
          &times;
        </span>

        <p className="header">
          您預約的門診為兒童成長發育專科(自費)(
          {selectedFirstFollow === "first" ? "初診" : "複診"})
        </p>
        <p className="header">
          時段為 {selectDate} {selectHour[0]}
          {selectHour[1].doctor}醫師
        </p>

        <form
          onSubmit={(event) =>
            handleSubmit(
              event,
              selectDate,
              // insertData,
              setData,
              setOrginalData,
              setShowForm,
              selectedFirstFollow,
              selectHour,
              clinic_name,
              setRegistrationOrQuery,
              setAlertMessage
            )
          }
        >
          {/* <label htmlFor="patient">姓名:</label>
          <input
            type="text"
            id="patient"
            name="patient"
            required
            defaultValue={randomPerson.patient}
            disabled={true}
          /> */}

          {/* <label htmlFor="phone">電話:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            defaultValue={randomPerson.phone}
            placeholder="請留手機號碼"
            disabled={true}
            required
          /> */}

          {/* <label htmlFor="email">電子信箱:</label>
          <input
            type="email"
            id="email"
            name="email"
            disabled={true}
            placeholder="請輸入電子信箱"
          /> */}
          <label htmlFor="ID">證件號碼:</label>
          <input
            type="text"
            id="ID"
            name="ID"
            required
            placeholder="身份證號碼或是其它證件號碼"
            defaultValue={randomPerson.ID}
          />
          <label htmlFor="birthday">出生日期 (Birthday):</label>
          <input
            type="text"
            id="birthday"
            name="birthday"
            required
            placeholder="請填寫西元生日 如:20210701"
            defaultValue={randomPerson.birthday}
          />

          {onsite && (
            <>
              <label htmlFor="verification">驗證碼:</label>

              <input
                type="text"
                id="verification"
                name="verification"
                required
                placeholder="請和櫃檯索取驗證碼"
              />
            </>
          )}

          {/* <label htmlFor="gender">性別:</label>
          <select
            id="性別"
            name="gender"
            defaultValue={randomPerson.gender}
            disabled={true}
          >
            <option value="男">男</option>
            <option value="女">女</option>
          </select> */}
          <p className="header">請選擇您想要預約的時段</p>
          {onsite ? (
            <div key="onsite">
              <input
                type="radio"
                id="onsite"
                name="timeTable"
                value="onsite"
                disabled={false}
                defaultChecked={true}
              />
              <label htmlFor="onsite" style={{ color: "black" }}>
                現場號
              </label>
            </div>
          ) : (
            (() => {
              let firstEnabledSet = false;
              return Object.keys(selectHour[1]).map((key) => {
                if (!key[1].toString().match(/\d+/)) {
                  return null;
                }

                const isfull =
                  selectedFirstFollow === "first"
                    ? selectHour[1][key].isFullFirst
                    : selectHour[1][key].isFullAll;
                const shouldBeDefaultChecked = !isfull && !firstEnabledSet;
                if (shouldBeDefaultChecked) {
                  firstEnabledSet = true;
                }

                return (
                  <div key={key}>
                    <input
                      type="radio"
                      id={key}
                      name="timeTable"
                      value={key}
                      disabled={isfull}
                      defaultChecked={shouldBeDefaultChecked}
                    />
                    <label
                      htmlFor={key}
                      style={{ color: isfull ? "gray" : "black" }}
                    >
                      {key}
                      {isfull && "(額滿)"}
                      {debug && (
                        <>
                          ({selectHour[1][key].people.first.length}/
                          {selectHour[1][key].people.follow.length})
                        </>
                      )}
                    </label>
                  </div>
                );
              });
            })()
          )}

          <input type="submit" value="提交" />
          <input
            type="button"
            value="取消"
            onClick={() => setShowForm(false)}
          />
          {/* {console.log("selectHour:", selectHour)} */}
        </form>
      </div>
    </div>
  );
};

export const QueryForm = ({
  orginalData,
  // deleteData,
  setOrginalData,
  setData,
  data,
  clinic_name,
  user,
}) => {
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmResult, setConfirmResult] = useState(null);
  const [dataFound, setDataFound] = useState([]);
  const [isCancelled, setIsCancelled] = useState(false);

  const handleSubmit = () => {
    console.log("submit");
    setIsCancelled(true);
    const id = document.getElementById("ID").value.toUpperCase();
    const birthday = document.getElementById("birthday").value;
    const dataTemp = [];

    orginalData.forEach((data) => {
      if (data.ID === id && data.birthday === birthday) {
        console.log("找到了", data);
        const [dateSlot, timeSlot, index] = data.date.split("_");
        data.dateSlot = dateSlot;
        data.timeSlot = timeSlot;
        dataTemp.push(data);
      }
    });
    setDataFound(dataTemp);
  };

  useEffect(() => {
    if (isCancelled) {
      handleSubmit();
    }
  }, [data, isCancelled]);
  const randomPerson =
    peopleList[Math.floor(Math.random() * peopleList.length)];

  return (
    <div>
      <div>
        {confirmMessage && confirmResult && (
          // <div>{alertMessage}</div>
          <ConfirmMsg
            confirmMessage={confirmMessage}
            onConfirm={confirmResult.handleConfirm}
            onCancel={confirmResult.handleCancel}
          />
        )}
        {/* <span className="close" onClick={() => setShowQueryForm(false)}>
          &times;
        </span> */}
        <p className="header">請填寫以下資訊查詢您的預約記錄</p>
        <label htmlFor="ID">證件號碼:</label>
        <input
          type="text"
          id="ID"
          name="ID"
          placeholder="請填寫初診填寫的身份證號碼或是護照號碼"
          defaultValue={randomPerson.ID}
        />

        <label htmlFor="birthday">出生日期 (Birthday):</label>
        <input
          type="text"
          id="birthday"
          name="birthday"
          required
          placeholder="請填寫西元生日 如:20210701"
          defaultValue={randomPerson.birthday}
        />
        <Button onClick={() => handleSubmit()}>查詢</Button>

        {isCancelled &&
          (dataFound.length === 0 ? (
            <h4>找不到預約記錄</h4>
          ) : (
            <div className="schedule-table">
              <h4>找到了以下預約記錄</h4>
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>預約日期</th>
                    <th>時段</th>
                    <th>預約時間</th>
                    <th>姓名</th>
                    <th>診別</th>
                    {/* <th>證件號碼</th> */}
                    <th>取消</th>
                  </tr>
                </thead>
                <tbody>
                  {dataFound.map((data) => (
                    <tr key={data.date}>
                      <td>{data.dateSlot}</td>
                      <td>{data.hour}</td>
                      <td>{data.timeSlot}</td>
                      <td>{data.name}</td>
                      <td>{data.first ? "初診" : "複診"}</td>
                      {/* <td>{data.phone}</td> */}
                      {/* <td>{data.ID}</td> */}
                      <td key={data.date}>
                        <Button
                          className="appointment-btn"
                          onClick={async (event) => {
                            event.preventDefault(); // 防止表單提交
                            // setConfirmMessage("確定取消預約嗎?")
                            const showConfirmDialog = (message) => {
                              return new Promise((resolve) => {
                                setConfirmMessage(message);
                                // setConfirm(true);

                                const handleConfirm = () => {
                                  // setConfirm(false);
                                  setConfirmMessage("");
                                  resolve(true);
                                };

                                const handleCancel = () => {
                                  // setConfirm(false);
                                  setConfirmMessage("");
                                  resolve(false);
                                };
                                setConfirmResult({
                                  handleConfirm,
                                  handleCancel,
                                });
                              });
                            };
                            if (
                              !["admin", "hansheng", "yoyo"].includes(
                                user?.account
                              ) &&
                              data.dateSlot === todayString
                            ) {
                              window.alert(
                                "當日無法取消，請於就診前一天前取消"
                              );
                              return;
                            }
                            const confirm = await showConfirmDialog(
                              "確定取消預約嗎?"
                            );
                            if (confirm) {
                              // setIsCancelled(true);
                              let result = await deleteData(
                                data,
                                setData,
                                setOrginalData,
                                clinic_name
                              );
                              // handleSubmit();

                              if (result) {
                                let { originalData_temp, data_temp } =
                                  await fetchData(clinic_name);
                                // console.log(
                                //   "originalData_temp",
                                //   originalData_temp
                                // );
                                // console.log("data_temp", data_temp);

                                setOrginalData(originalData_temp);
                                setData(data_temp);
                              } else {
                                setData(false);
                              }
                            } else {
                              console.log("取消操作");
                            }
                          }}
                          // disabled={isFull}
                          style={{
                            backgroundColor: "#F4A7B9",
                            // margin: "0px",
                            // height: "150px", // Set the height
                            // width: "200px", // Set the width
                          }}
                        >
                          取消預約
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <br />
              <br />
            </div>
          ))}
      </div>
    </div>
  );
};
